<template>
    <Form :items="baseItems" :rules="rules" :formData="baseFormData" @change="handleChange" ref="form" labelWidth="120px">
        <span slot="footer">
            <span v-show="value.lastEditor.editor" class="last-editor">{{`最后编辑人：${value.lastEditor.editor} ${value.lastEditor.editTime}`}}</span>
            <el-button round type="primary" @click="submit">{{ $t("zhiji.common.save") }}</el-button>
        </span>
    </Form>
</template>

<script>
import Form from "@/views/zhiji/components/form/Form";
import { allSupportLangs } from "@/components/langSelect/languages.js";
import { updateBaseInfo } from "../service.js";

export default {
    components: {
        Form
    },
    props: ["value", "businessName"],
    model: {
        props: "value",
        event: "change"
    },
    data() {
        return {
            rules: {
                languages: [{ required: true, message: this.$t("zhiji.business.selectLangs"), trigger: "change" }],
                modules: [
                    {
                        validator: (rule, value, callback) => {
                            setTimeout(() => {
                                if (this.baseFormData.modules.length == 0) {
                                    callback(new Error(this.$t("zhiji.business.oneAtLess")));
                                } else {
                                    callback();
                                }
                            }, 50);
                        },
                        trigger: "change",
                        type: "array"
                    }
                ],
                tipFormat: [
                    {
                        required: true,
                        message: "攻略组件内容类型不能为空"
                    }
                ]
            },
            baseFormData: this.value
        };
    },
    computed: {
        baseItems() {
            return [
                {
                    name: "languages",
                    label: this.$t("zhiji.business.supportLangs"),
                    type: "Select",
                    extendProps: {
                        placeholder: this.$t("zhiji.business.selectLangs"),
                        options: allSupportLangs.map(lang => ({ value: lang.lang, i18nKey: lang.i18nKey })),
                        multiple: true,
                        filterable: true
                    }
                },
                {
                    name: "modules",
                    label: this.$t("zhiji.business.module"),
                    type: "CheckGroup",
                    extendProps: {
                        items: [
                            {
                                label: this.$t("zhiji.menu.robot"),
                                value: "robot"
                            },
                            {
                                label: this.$t("zhiji.business.tiket"),
                                value: "ticket"
                            },
                            // {
                            //     label: this.$t("zhiji.business.im"),
                            //     value: "im"
                            // }
                            {
                                label: "titan",
                                value: "titan"
                            },
                            {
                                label: "uo",
                                value: "uo"
                            }
                        ]
                    }
                },
                {
                    name: "tipFormat",
                    label: "攻略组件",
                    type: "RadioGroup",
                    extendProps: {
                        items: [
                            {
                                label: "富文本样式",
                                value: 0
                            },
                            {
                                label: "图文混排",
                                value: 1
                            },
                        ]
                    }
                }
            ];
        }
    },
    watch: {
        value() {
            this.baseFormData = this.value;
        }
    },
    methods: {
        submit() {
            this.$refs.form.validate(async isValid => {
                if (!isValid) {
                    return;
                }
                await updateBaseInfo(this.businessName, this.baseFormData);
                this.$emit("submit", this.baseFormData);
            });
        },
        handleChange(formData) {
            this.baseFormData = formData;
            this.$emit("change", this.baseFormData);
        }
    }
};
</script>

<style>
.last-editor {
    font-size: 14px;
    padding-right: 10px;
}
</style>
